<template>
    <section class="outContainer">
      <div class="role">
        <el-button type="primary" @click="handleAdd(null)">新增</el-button>
      </div>
      <div class="tableContainer">
        <!-- 表格 -->
        <el-table
         height="100%"
         :data="roleData"
         style="width: 100%;">
          <el-table-column align="center" label="角色名称" prop="name">
          </el-table-column>
          <el-table-column align="center" label="创建时间" prop="createTime">
          </el-table-column>
          <el-table-column align='center' label="操作" fixed="right" >
            <template slot-scope="scope">
                <el-button size="mini" @click="handleAdd(scope.row)">编辑</el-button>
                <el-button size="mini" @click="handleRights(scope.$index, scope.row)">权限分配</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 新增、编辑 -->
        <el-drawer :title="row ? '编辑' : '新增'"
          :visible.sync="addDrawer"
          :direction="direction"
          :before-close="handleClose"
          size="50%">
          <add v-if="addDrawer" @close='handleClose' ref='newForm' :id="id" :row="row"></add>
        </el-drawer>
        <!-- 权限 -->
        <el-drawer title="权限设置"
          size="50%"
          :visible.sync="rightsDrawer"
          :direction="direction"
          :before-close="handleClose">
          <rights v-if="rightsDrawer" @close='handleClose' @success="handleDrawerSuccess(form)  "  ref='newForm' :id="id" :row="row"></rights>
        </el-drawer>
      </div>
    </section>
</template>

<script>
  import { getRoleList } from '@/api/public.js';
  import { timeChange } from '@/api/publicFun.js';
  import add from './add.vue';
  import rights from './rights.vue';
  export default {
    data() {
      return {
        roleData: [],
        addDrawer:false,
        rightsDrawer:false,
        id:'',
        row:'',
        pageIndex:1,
        pageSize:10,
        direction:'rtl',
        total:0,
      }
    },
  
    components: {add,rights},
  
    computed: {},
  
    mounted() {
      this.init();
    },
  
    methods: {
      // 页面初始化
      async init(){
        await getRoleList({pageIndex:this.pageIndex,pageSize:this.pageSize,param:{}}).then(res=>{
          if(res.success){
            this.roleData = res.data;
            this.roleData.forEach((element) => {
              element.createTime = timeChange(element.createTime,'seconds');
            });
          }else{
            this.roleData = [];
            this.$message({
              message:res.msg,
              type:'fail',
            })
          }
        });
      },
      // 打开新增菜单
      handleAdd(row){
        this.row = row;
        this.addDrawer=true;
      },
      // 权限分配
      handleRights(index,row){
        this.rightsDrawer = true;
        this.row = row;
      },
      // 关闭
      handleClose(){
        this.row = null;
        this.addDrawer=false;
        this.rightsDrawer = false;
        this.init();
      },
      // 新增成功
      handleDrawerSuccess(){
        this.addDrawer=false;
        this.rightsDrawer = false;
        this.init();
      },
      // 分页
      prevpage(val){
          this.pageIndex=val;
          this,init();
      },
      nextpage(val){
          this.pageIndex=val;
          this,init();
      },
      handleCurrentChange(val){
          this.pageIndex =val;
          this.init();
      },
    },
  };
</script>
<style scoped>
  .role{
    width: 100%;
    background-color: white;
    height: 60px;
    width: 100%;
    padding: 10px 50px;
    position: relative;
  }
  .role button{
    position: absolute;
    right:20px;
    top:10px;
  }
</style>
    